export default __webpack_public_path__ + "static/media/neetfailedicon.585707c1.svg";